import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import './intel.css';

const AGENT_META = {
  nova: { name: 'Nova', role: 'Environmental', color: '#e8a598' },
  orion: { name: 'Orion', role: 'Space Weather', color: '#00E5FF' },
  vega: { name: 'Vega', role: 'Infrastructure', color: '#6366F1' },
  atlas: { name: 'Atlas', role: 'Geopolitics', color: '#059669' },
  karbon: { name: 'Karbon', role: 'Mangrove · Blue Carbon', color: '#00e5b0' },
  delta: { name: 'Delta', role: 'Global Sensor Control', color: '#e8c878' },
  producer: { name: 'Producer', role: 'Editorial Orchestration', color: '#b48ef8' },
};

const STATE_COLORS = {
  CALM: '#7ecfc0', NOMINAL: '#7ecfc0',
  WATCH: '#e8c878', ELEVATED: '#e8c878',
  ALERT: '#e8a598',
  SEVERE: '#e87878', CRITICAL: '#e87878', STORM: '#e87878',
};

export default function IntelBriefingModal({ onClose, onNavigate }) {
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/intel/briefing-blocks')
      .then(r => setBlocks(r.data.blocks || []))
      .catch(() => setBlocks([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="intel-overlay" data-testid="intel-overlay">
      <div className="intel-panel">
        <div className="intel-header">
          <div>
            <div className="intel-title">Intelligence Briefing</div>
            <div className="intel-sub">Cross-agent snapshot · what changed · why it matters · what to watch next</div>
          </div>
          <button className="intel-close" onClick={onClose} data-testid="intel-close-btn">✕</button>
        </div>
        <div className="intel-body">
          {loading && <div className="intel-loading">Loading briefing…</div>}
          {!loading && blocks.map((b, idx) => {
            const meta = AGENT_META[b.agent] || { name: b.agent, role: '', color: '#888' };
            const stateCol = STATE_COLORS[b.state?.toUpperCase?.()] || meta.color;
            return (
              <div key={idx} className="intel-card" data-testid={`intel-card-${b.agent}`}>
                <div className="intel-card-head">
                  <div className="intel-card-brand">
                    <span className="intel-agent-dot" style={{ background: meta.color, boxShadow: `0 0 8px ${meta.color}` }} />
                    <span className="intel-agent-name">{meta.name}</span>
                    <span className="intel-agent-role">{meta.role}</span>
                  </div>
                  <span className="intel-state" style={{ color: stateCol, borderColor: stateCol }}>
                    {b.state}
                  </span>
                </div>
                <div className="intel-blocks">
                  <div className="intel-block">
                    <div className="intel-block-label intel-label-change">WHAT CHANGED</div>
                    <div className="intel-block-text">{b.what_changed || '—'}</div>
                  </div>
                  <div className="intel-block">
                    <div className="intel-block-label intel-label-matters">WHY IT MATTERS</div>
                    <div className="intel-block-text">{b.why_it_matters || '—'}</div>
                  </div>
                  <div className="intel-block">
                    <div className="intel-block-label intel-label-watch">WHAT TO WATCH NEXT</div>
                    <div className="intel-block-text">{b.what_to_watch_next || '—'}</div>
                  </div>
                </div>
                <div className="intel-card-foot">
                  <span>Confidence {Math.round((b.confidence || 0) * 100)}%</span>
                  {onNavigate && (
                    <button
                      className="intel-open-agent"
                      onClick={() => { onClose(); onNavigate(b.agent); }}
                      data-testid={`intel-open-${b.agent}`}
                    >
                      OPEN {meta.name.toUpperCase()} →
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
